import { Theme } from "@mui/material";
import { maxHeight, padding } from "@mui/system";

const useStyles = (theme: Theme) => ({
  pageContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    padding: 3,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 2,
    //mt: 2,
    width: "100%",
    height: "100%",
    maxHeight: "fit-content",
  },
  formContainer: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
    gap: 2,
    alignItems: "center",
  },
  textfield: {
    backgroundColor: theme.palette.background.textField,
    borderRadius: 1,
    maxHeight: "56px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "& .MuiFormHelperText-root": {
      margin: 0,
      padding: 0,
      minHeight: "20px",
    },
  },
  textArea: {
    backgroundColor: theme.palette.background.textField,
    borderRadius: 1,
    maxHeight: "125px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "& .MuiFormHelperText-root": {
      margin: 0,
      padding: 0,
      minHeight: "20px",
    },
  },
  queryContainer: {
    marginY: 2,
    width: "100%",
  },
  dataGrid: {
    width: "100%",
    height: "82%",
    fontSize: 12,
    borderRadius: 0,
    border: 0,
    backgroundColor: "transparent",
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    ".MuiDataGrid-cell": {
      display: "flex",
      alignItems: "center",
      borderColor: theme.palette.stroke,
    },
    "& .MuiDataGrid-scrollbar--vertical": {
      display: "none",
    },
    "& .MuiDataGrid-filler": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller--borderTop": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller--header": {
      // display: "none",
      backgroundColor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.stroke}`,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      color: "text.secondary", // Altera a cor do titulo do cabeçalho
    },
    "& .MuiDataGrid-footerContainer": {
      backgroundColor: "transparent", // Altera cor do rodapé
      border: 0,
      borderTop: `1px solid ${theme.palette.stroke}`,
      height: "30px",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: theme.palette.background.paper, // Altera cor do cabeçalho
      border: 0,
      borderTop: `1px solid ${theme.palette.stroke}`,
      width: "100%",
    },
    "& .MuiDataGrid-topContainer": {
      border: 0,
      backgroundColor: theme.palette.background.paper,
    },
    "& .MuiDataGrid-row--borderBottom": {
      border: 0,
    },
    "& .MuiDataGrid-columnHeaders": {
      border: 0,
      height: "40px",
      backgroundColor: theme.palette.background.paper,
    },

    "& .even-row": { backgroundColor: "table" },
    "& .odd-row": { backgroundColor: "background.paper" },
  },
});

export default useStyles;
